export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";